<script>
  import options from './PostsList.options'
  export default options
</script>

<template>
  <article class="kb-posts-list">
    <div class="kb-posts-list__container">
      <div class="kb-posts-list__container-group">
        <div class="kb-posts-list__container-group-element">
          {{ totalAmount }} {{ getLabel('numberOfPostsLabel') }}
        </div>
        <div class="kb-posts-list__container-group-element" v-if="isLoggedIn">
          <button v-on:click="openMemberOverlay" class="kb-link">
            {{ numberOfMembers }} {{ getLabel('numberOfMembersLabel') }}
          </button>
        </div>
      </div>
    </div>

    <ul class="kb-posts-list__wrapper">
      <template v-for="post, index in posts" :key="post.id">
        <li class="kb-posts-list__wrapper-element">
          <GroupPost 
            :result="post"
            :isFrivilligContext="false"
            :handlePostClick="handlePostClick"
          />
        </li>
      </template>
    </ul>

    <div class="kb-posts-list__actions">
      <p class="kb-posts-list__actions-element">{{ getLabel('resultOutForTitle', [posts.length, totalAmount]) }}</p>
      <button v-if="posts.length < totalAmount" v-on:click="getMorePosts" class="kb-button kb-button--full-color-spot">{{ getLabel('getMoreButtonLabel') }}</button>
    </div>
  </article>

  <div v-if="showSpinner" class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner"></div>
    </div>
</template>
